import React from 'react';
import PropTypes from 'prop-types';
import { Image, Link, useMediaQuery } from '@podiumhq/design-system';

import logoWithText from '../../images/logo-with-text.svg';
import logoWithoutText from '../../images/logo-without-text.svg';

const PodiumLogo = ({
  icon = false,
  redirectUrl = '',
  invert = false,
  maxWidth = '128px',
  mobileMaxWidth = '96px',
  ...wrapperStyleProps
}) => {
  const [isSmallerThan650px] = useMediaQuery('(max-width: 650px)');
  const [isSmallerThan800px] = useMediaQuery('(max-width: 800px)');

  const baseStyles = redirectUrl
    ? logoBaseStyles
    : { ...logoBaseStyles, pointerEvents: 'none' };
  const maxWidthToDisplay = isSmallerThan800px ? mobileMaxWidth : maxWidth;

  return icon || isSmallerThan650px ? (
    <Link href={redirectUrl} {...baseStyles} {...wrapperStyleProps}>
      <Image
        alt="Podium Logo"
        filter={invert ? 'invert(100%)' : 'invert(0%)'}
        maxWidth={mobileMaxWidth}
        src={logoWithoutText}
      />
    </Link>
  ) : (
    <Link
      href={redirectUrl}
      margin="0 32px 48px 0"
      maxWidth={maxWidthToDisplay}
      {...baseStyles}
      {...wrapperStyleProps}
    >
      <Image
        alt="Podium Logo"
        maxWidth={maxWidthToDisplay}
        src={logoWithText}
      />
    </Link>
  );
};

PodiumLogo.propTypes = {
  icon: PropTypes.bool,
  invert: PropTypes.bool,
  maxWidth: PropTypes.string,
  mobileMaxWidth: PropTypes.string,
  redirectUrl: PropTypes.string,
};

const logoBaseStyles = {
  transition: 'all 200ms 200ms',
  whiteSpace: 'nowrap',
};

export default PodiumLogo;
